module.exports = __webpack_public_path__ + "/login_ui/img/se-2ca8780d199dff094ea8cf19250d9fd7.svg";